module.exports = __webpack_public_path__ + "static/media/IMG_1161.8d22f0a1.jpg";